(function () {
  var VAT_MULTIPLIER = 1.15;

  // Every known Algolia price selector across all components
  var SELECTORS = [
    '.aa-ItemContentPriceCurrent',    
    '.ais-hit--price b',             // InstantSearch full results
    '.ais-hit--price strong',        // InstantSearch variant
    '.alg-price',                    // Some Algolia themes
    '.algolia-price-current',        // Some Algolia themes
  ].join(', ');

  function applyVat(el, rawPrice) {
    var vatPrice = Math.round(rawPrice * VAT_MULTIPLIER * 100) / 100;
    var formatted = vatPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // Preserve currency symbol, replace only the number
    el.textContent = el.textContent.replace(/[\d,]+\.?\d*/g, formatted);
    el.setAttribute('data-raw-price', rawPrice);
    el.setAttribute('data-vat-done', 'true');
  }

  function processElement(el) {
    // Already patched — re-apply from stored raw price (handles Algolia re-renders)
    if (el.getAttribute('data-vat-done') === 'true') {
      var stored = parseFloat(el.getAttribute('data-raw-price'));
      if (!isNaN(stored)) applyVat(el, stored);
      return;
    }

    // Fresh element — read raw price immediately
    var raw = parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
    if (isNaN(raw) || raw === 0) return;
    applyVat(el, raw);
  }

  function processNode(node) {
    if (node.nodeType !== 1) return;
    if (node.matches && node.matches(SELECTORS)) processElement(node);
    if (node.querySelectorAll) {
      node.querySelectorAll(SELECTORS).forEach(processElement);
    }
  }

  // Watch for Algolia injecting new nodes
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(processNode);
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Patch anything already rendered on page load
  function patchExisting() {
    document.querySelectorAll(SELECTORS).forEach(processElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchExisting);
  } else {
    patchExisting();
  }

})();